type Falsey = false | null | undefined | 0 | '';

export const compact = <T>(array: Array<T | Falsey> | null | undefined): T[] => {
  if (!array) return [];

  return array?.filter(Boolean) as T[];
};
